/**
 * Build a path with organization context - KISS principle
 * @param orgSlug - The organization slug
 * @param path - The path to append
 * @returns Full organization path
 */
export function buildOrgPath(orgSlug: string, path: string): string {
  // If path already includes org context, return as-is
  if (path.startsWith("/orgs/")) {
    return path;
  }

  // Ensure path starts with /
  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  return `/orgs/${orgSlug}${cleanPath}`;
}
